import { useContentTypeServiceContentTypePinedList } from '@cms/api/queries'
import { CUSTOM_CONTENT_PER_PAGE } from '@cms/app-constants'
import { PinedContentType } from '@cms/types'
import { WithResults } from '@shared/types'
import { useLocation } from 'react-router-dom'

export const useSidebarComponents = () => {
  const { pathname } = useLocation()

  const queryParams = {
    page: 1,
    page_size: CUSTOM_CONTENT_PER_PAGE
  }

  const { data, isLoading } = useContentTypeServiceContentTypePinedList(
    { ...queryParams },
    [queryParams],
    { enabled: pathname.startsWith('/apps/cms') }
  )

  const defaultData: WithResults<PinedContentType> = {
    count: 0,
    total_pages: 0,
    per_page: CUSTOM_CONTENT_PER_PAGE,
    current_page: 1,
    results: []
  }

  return { sidebarComponents: data ?? defaultData, isLoading }
}
